import React from "react";

/**
 * AncientScroll
 * - Non-invasive: wrap your existing content.
 * - Tailwind-only + inline styles (no global CSS).
 * - Parchment texture, scroll caps, subtle noise, and a wax "SAFU" seal.
 */
export default function AncientScroll({ children, className = "", sealText = "SAFU" }) {
  return (
    <div className={`relative py-6 ${className}`}>
      {/* Outer shadow for depth */}
      <div className="absolute inset-0 -z-10 mx-2 rounded-[28px] shadow-[0_20px_60px_rgba(0,0,0,0.18)]" />

      {/* Scroll body */}
      <div
        className="relative rounded-[28px] border border-[#d7c9a6] p-4 sm:p-6 md:p-8"
        style={{
          background:
            // Layer 1: parchment color
            "linear-gradient(180deg,#f8f1da 0%, #f3ebcf 100%)",
          // Layer 2: subtle paper grain (data URI SVG)
          backgroundImage:
            "radial-gradient(rgba(0,0,0,0.04) 1px, transparent 1px)",
          backgroundSize: "6px 6px",
          boxShadow:
            "inset 0 1px 0 rgba(255,255,255,.5), inset 0 -2px 10px rgba(0,0,0,.08)",
        }}
      >
        {/* Top & bottom “roll” caps using pseudo-elements */}
        <div
          className="pointer-events-none absolute left-0 right-0 -top-4 mx-auto h-4 w-[92%] rounded-full"
          style={{
            background:
              "radial-gradient(ellipse at center, rgba(0,0,0,0.18) 0%, rgba(0,0,0,0) 70%)",
            filter: "blur(2px)",
          }}
        />
        <div
          className="pointer-events-none absolute left-0 right-0 -bottom-4 mx-auto h-4 w-[92%] rounded-full"
          style={{
            background:
              "radial-gradient(ellipse at center, rgba(0,0,0,0.18) 0%, rgba(0,0,0,0) 70%)",
            filter: "blur(2px)",
          }}
        />

        {/* Very subtle edge darkening for scroll feel */}
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 rounded-[28px]"
          style={{
            boxShadow:
              "inset 0 0 40px rgba(0,0,0,.06), inset 0 0 2px rgba(0,0,0,.25)",
          }}
        />

        {/* Wax seal (fun, optional) */}
        <div
          className="absolute -right-3 -top-3 select-none"
          style={{ transform: "rotate(8deg)" }}
          aria-hidden
        >
          <div className="relative h-14 w-14 rounded-full bg-[#b00020] text-white shadow-[0_6px_20px_rgba(0,0,0,.25)] ring-4 ring-[#6d0a17]">
            <div className="absolute inset-0 rounded-full"
              style={{
                boxShadow:
                  "inset 0 6px 10px rgba(255,255,255,.25), inset 0 -10px 18px rgba(0,0,0,.35)",
              }}
            />
            <span className="absolute inset-0 grid place-items-center text-[10px] font-black tracking-widest">
              {sealText}
            </span>
          </div>
        </div>

        {/* Content */}
        <div className="relative">
          {children}
        </div>
      </div>
    </div>
  );
}
